var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _path28, _path29, _path30, _g2, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _g3, _path64, _path65, _path66, _path67, _g4, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _g5, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _g6, _path199, _path200, _path201, _g7, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 200,
    viewBox: "0 0 280 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.052 52.8881C257.052 52.8881 233.852 14.8881 176.652 7.28812C119.452 -0.311883 109.052 30.8881 97.452 41.6881C85.852 52.4881 65.852 50.4881 35.052 71.2881C4.25201 92.0881 4.65201 115.288 13.452 137.688C22.252 160.088 52.652 179.688 88.652 182.488C124.652 185.288 143.052 168.488 172.252 168.888C201.452 169.288 226.252 181.288 249.452 172.088C272.652 162.888 289.452 88.8881 257.052 52.8881Z",
    fill: "#EB6502"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M257.052 52.8881C257.052 52.8881 233.852 14.8881 176.652 7.28812C119.452 -0.311883 109.052 30.8881 97.452 41.6881C85.852 52.4881 65.852 50.4881 35.052 71.2881C4.25201 92.0881 4.65201 115.288 13.452 137.688C22.252 160.088 52.652 179.688 88.652 182.488C124.652 185.288 143.052 168.488 172.252 168.888C201.452 169.288 226.252 181.288 249.452 172.088C272.652 162.888 289.452 88.8881 257.052 52.8881Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M241.2 23.6001H74.168V128.98H241.2V23.6001Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2173_7287)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M237.684 26.8882H77.684V125.688H237.684V26.8882Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M70.6138 51.8471C70.6138 51.8471 60.1373 78.9026 74.86 106.146C89.5828 133.39 119.908 147.782 144.179 160.088C168.45 172.395 193.653 166.401 205.629 146.245C217.604 126.088 201.179 111.7 201.157 82.9572C201.134 54.2145 205.459 46.6051 189.884 22.3227C174.308 -1.95965 136.126 -7.33694 107.252 10.6738C78.3773 28.6845 70.6138 51.8471 70.6138 51.8471Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4725 48.0555C86.306 28.1133 113.546 4.84176 150.924 14.5367C188.302 24.2316 213.55 44.7374 209.413 80.4207C205.275 116.104 183.529 145.756 136.693 146.62C89.8571 147.485 51.7238 91.7728 75.4725 48.0555Z",
    fill: "#EB6502"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M75.4725 48.0555C86.306 28.1133 113.546 4.84176 150.924 14.5367C188.302 24.2316 213.55 44.7374 209.413 80.4207C205.275 116.104 183.529 145.756 136.693 146.62C89.8571 147.485 51.7238 91.7728 75.4725 48.0555Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0222 43.5914C74.0222 43.5914 74.9654 39.9727 81.3197 39.9539C87.674 39.9351 91.3979 46.2932 91.3979 46.2932C91.3979 46.2932 94.0621 43.5237 97.2825 45.3725C100.503 47.2213 100.495 48.2697 100.495 48.2697H108.762",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M208.195 49.3517C208.195 49.3517 207.252 45.7293 200.898 45.7105C194.543 45.6917 190.82 52.0535 190.82 52.0535C190.82 52.0535 188.155 49.2841 184.935 51.1329C181.715 52.9817 181.722 54.0301 181.722 54.0301H173.455",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.939 42.7947H188.279C188.279 42.7947 189.553 40.1079 186.675 36.9289C183.796 33.7499 180.869 35.8655 180.869 35.8655C180.869 35.8655 178.043 26.1931 169.803 27.3279C161.562 28.4628 160.694 36.4066 160.694 36.4066C160.694 36.4066 158.932 34.4563 155.343 35.7377C151.754 37.0191 151.209 41.9304 152.1 44.0047C152.1 44.0047 148.015 44.7976 147.741 48.2847C147.741 48.2847 147.489 45.1996 143.645 45.1057C139.801 45.0117 138.839 49.7841 138.839 49.7841H134.521",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0423 35.8729L109.597 34.7982C111.968 26.8732 120.934 30.1875 120.934 30.1875C124.327 21.9656 132.267 25.8849 132.267 25.8849C132.267 25.8849 136.295 17.9636 144.246 19.6208C146.488 20.0418 148.569 21.0743 150.26 22.6043C151.951 24.1342 153.186 26.1018 153.829 28.2898L159.315 28.5191",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4342 116.581V93.8321H81.0041L84.123 90.7095V86.2002H85.1639V106.462",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.966 119.888V108.021H92.668V129.711",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0423 106.462V98.7773H92.668V92.3441H93.8855V81.9954H94.8625V89.8678H96.2642V98.9727L98.143 100.852V105.947H101.615",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8358 131.094V116.904H98.8382V110.065H102.803V98.9727H104.61",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M184.266 109.72V106.462H181.891V100.134H180.899V106.387H177.048V109.028",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M196.482 106.826V98.8262L191.8 94.144H190.015V100.134H188.828V101.205H190.015V110.817H179.708V126.904V135.719",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M192.939 127.355V108.021H202.901V112.884",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M199.53 106.462V92.344H200.522V106.462",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M177.048 134.84V121.072H167.101V103.057L159.033 94.9859V86.5798H157.316V121.812",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M160.104 138.816V123.68H149.519V113.308H148.139V98.4654H146.869V84.3364H145.175V67.374H143.687V83.69L141.721 85.6516V93.8321H138.151V113.293H130.959V125.69H126.172V138.816",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 105.947H111.34V119.524H115.789V130.654",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M112.216 110.546H115.789V97.7251H132.83V110.817",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M149.601 108.021H155.681",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M171.783 119.888V96.0117H170.494V120.204",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M170.494 42.9827V54.6278H169.325V44.7864H162.201V54.6278H161.032V44.7864H120.734V54.6278H119.566V44.7864H112.441V54.6278H111.272V42.9827H170.494Z",
    fill: "#EB6502"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2173_7287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 42,
    width: 60,
    height: 13
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M170.494 42.9827V54.6278H169.325V44.7864H162.201V54.6278H161.032V44.7864H120.734V54.6278H119.566V44.7864H112.441V54.6278H111.272V42.9827H170.494Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2173_7287)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M170.494 42.9827V47.9278H169.325V44.7864H162.201V47.9278H161.032V44.7864H120.734V47.9278H119.566V44.7864H112.441V47.9278H111.272V42.9827H170.494Z",
    fill: "black"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M170.494 42.9827V54.6278H169.325V44.7864H162.201V54.6278H161.032V44.7864H120.734V54.6278H119.566V44.7864H112.441V54.6278H111.272V42.9827H170.494Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M168.754 40.439H152.322H144.363H112.903L104.61 45.5232H136.46H148.951H177.048L168.754 40.439Z",
    fill: "#EB6502"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2173_7287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 40,
    width: 74,
    height: 6
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M168.754 40.439H152.322H144.363H112.903L104.61 45.5232H136.46H148.951H177.048L168.754 40.439Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2173_7287)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M168.754 40.439H152.322H144.363H112.903L104.61 45.5232H136.46H148.951H177.048L168.754 40.439Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M154.261 40.439H129.415V45.5232H160.683L154.261 40.439Z",
    fill: "black"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M168.754 40.439H152.322H144.363H112.903L104.61 45.5232H136.46H148.951H177.048L168.754 40.439Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M124.432 41.4158H167.394",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M156.748 42.498H126.318",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M119.122 43.7493H154.092",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M158.127 42.498H159.168",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M162.505 42.498H166.53",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M169.213 41.4158H169.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M156.196 43.7493H164.745",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M166.53 43.7493H167.672",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M170.494 43.7493H174.15",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M109.544 42.498H117.469",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M121.482 42.498H122.527",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M121.482 41.4158H113.505",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M111.272 43.7493H113.159",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M173.636 54.2898V137.985C163.644 143.246 151.405 146.346 136.693 146.628C126.731 146.764 116.887 144.461 108.018 139.921V54.2898H173.636Z",
    fill: "#EB6502",
    stroke: "#EB6502",
    strokeWidth: 0.375772,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.636 54.2898V137.985C163.644 143.246 151.405 146.346 136.693 146.628C126.731 146.764 116.887 144.461 108.018 139.921V54.2898H173.636Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.411 54.6279H151.506V144.501H154.411V54.6279Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.23 139.868L120.734 143.626V55.7778L122.23 59.5355V139.868Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.709 117.806L164.557 120.655H173.636V117.806H161.709Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.709 101.205L164.557 104.053H173.636V101.205H161.709Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.709 84.6069L164.557 87.4553H173.636V84.6069H161.709Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.709 68.0093L164.557 70.8576H173.636V68.0093H161.709Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.973 117.806L110.822 120.655H120.652V117.806H107.973Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.973 101.205L110.822 104.053H120.652V101.205H107.973Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.973 84.6069L110.822 87.4553H120.652V84.6069H107.973Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.973 68.0093L110.822 70.8576H120.652V68.0093H107.973Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M108.92 50.592H172.734",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M108.92 51.543H172.734",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M108.92 52.4937H172.734",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M108.92 53.4443H172.734",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M172.734 49.7466H108.92V54.2897H172.734V49.7466Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M177.859 44.7864H103.795V46.0152H177.859V44.7864Z",
    fill: "#EB6502"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2173_7287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 44,
    width: 75,
    height: 3
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M177.859 44.7864H103.795V46.0152H177.859V44.7864Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2173_7287)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M177.859 44.7864H103.795V46.0152H177.859V44.7864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.032 44.7864H129.415V46.0152H161.032V44.7864Z",
    fill: "black"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M177.859 44.7864H103.795V46.0152H177.859V44.7864Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M108.018 139.913V54.2898H173.636V137.985",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M129.125 147.222V40.439H152.528V146.47",
    fill: "#EB6502"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2173_7287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 40,
    width: 24,
    height: 108
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M129.125 147.222V40.439H152.528V146.47",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2173_7287)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M152.528 41.416H129.125V44.1967H152.528V41.416Z",
    fill: "black"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M129.125 147.222V40.439H152.528V146.47",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M137.359 57.3335H130.869V62.2787H137.359V57.3335Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M137.171 57.5212H134.304V62.0906H137.171V57.5212Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M136.983 57.7093V61.9029H134.491V57.7093H136.983ZM137.359 57.3335H134.116V62.2787H137.359V57.3335Z",
    fill: "#263238"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M119.149 57.3335H109.131V66.8217H119.149V57.3335Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M112.441 57.3335V66.8217",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M118.777 57.7093V66.446H116.165V57.7093H118.777ZM119.152 57.3335H115.789V66.8217H119.152V57.3335Z",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M119.945 66.8218H105.734V68.0581H119.945V66.8218Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 63.124H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 64.0747H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 65.0254H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 65.9761H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M119.945 62.2786H105.734V66.8216H119.945V62.2786Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M125.976 57.3335H123.842V62.2787H125.976V57.3335Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M144.295 62.2786H150.785V57.3334H144.295V62.2786Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M147.35 57.5212H144.483V62.0906H147.35V57.5212Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M147.166 57.7093V61.9029H144.667V57.7093H147.162M147.538 57.3335H144.292V62.2787H147.538V57.3335Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M162.505 66.8218H172.523V57.3335H162.505V66.8218Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M169.213 57.3335V66.8217",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M165.489 57.7093V66.446H162.881V57.7093H165.489ZM165.865 57.3335H162.505V66.8217H165.865V57.3335Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M161.712 68.0618H175.924V66.8255H161.712V68.0618Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 63.124H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 64.0747H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 65.0254H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 65.9761H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M161.712 66.8254H175.924V62.2824H161.712V66.8254Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M155.677 62.2786H157.812V57.3334H155.677V62.2786Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M137.359 73.9199H130.869V78.8651H137.359V73.9199Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M137.171 74.1079H134.304V78.6773H137.171V74.1079Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M136.983 74.2957V78.4931H134.491V74.2957H136.983ZM137.359 73.9199H134.116V78.8688H137.359V73.9199Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M119.149 73.9199H109.131V83.4082H119.149V73.9199Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M112.441 73.9199V83.4082",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M118.777 74.2957V83.0324H116.165V74.2957H118.777ZM119.152 73.9199H115.789V83.4082H119.152V73.9199Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M119.945 83.4082H105.734V84.6445H119.945V83.4082Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 79.7107H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 80.6614H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 81.6121H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 82.5627H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M119.945 78.8652H105.734V83.4083H119.945V78.8652Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M125.976 73.9199H123.842V78.8651H125.976V73.9199Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M144.295 78.8652H150.785V73.9201H144.295V78.8652Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M147.35 74.1079H144.483V78.6773H147.35V74.1079Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M147.166 74.2957V78.4931H144.667V74.2957H147.162M147.538 73.9199H144.292V78.8688H147.538V73.9199Z",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M162.505 83.4082H172.523V73.92H162.505V83.4082Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M169.213 73.9199V83.4082",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M165.489 74.2957V83.0324H162.881V74.2957H165.489ZM165.865 73.9199H162.505V83.4082H165.865V73.9199Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M161.712 84.6445H175.924V83.4082H161.712V84.6445Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 79.7107H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 80.6614H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 81.6121H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 82.5627H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M161.712 83.4082H175.924V78.8651H161.712V83.4082Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M155.677 78.8652H157.812V73.9201H155.677V78.8652Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M137.359 90.5066H130.869V95.4517H137.359V90.5066Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M137.171 90.6946H134.304V95.264H137.171V90.6946Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M136.983 90.8936V95.0872H134.491V90.8936H136.983ZM137.359 90.5178H134.116V95.463H137.359V90.5178Z",
    fill: "#263238"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M119.149 90.5066H109.131V99.9948H119.149V90.5066Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M112.441 90.5066V99.9948",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M118.777 90.8936V99.6303H116.165V90.8936H118.777ZM119.152 90.5178H115.789V100.006H119.152V90.5178Z",
    fill: "#263238"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M119.945 99.9949H105.734V101.231H119.945V99.9949Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 96.2971H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 97.248H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 98.1987H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 99.1494H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M119.945 95.4519H105.734V99.995H119.945V95.4519Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M125.976 90.5066H123.842V95.4517H125.976V90.5066Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M144.295 95.4519H150.785V90.5067H144.295V95.4519Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M147.35 90.6946H144.483V95.264H147.35V90.6946Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M147.166 90.8936V95.0872H144.667V90.8936H147.162M147.538 90.5178H144.292V95.463H147.538V90.5178Z",
    fill: "#263238"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M162.505 99.9949H172.523V90.5066H162.505V99.9949Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M169.213 90.5066V99.9948",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M165.489 90.8936V99.6303H162.881V90.8936H165.489ZM165.865 90.5178H162.505V100.006H165.865V90.5178Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M161.712 101.231H175.924V99.9947H161.712V101.231Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 96.2971H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 97.248H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 98.1987H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 99.1494H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M161.712 99.9949H175.924V95.4518H161.712V99.9949Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M155.677 95.4519H157.812V90.5067H155.677V95.4519Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M137.359 107.093H130.869V112.038H137.359V107.093Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M137.171 107.281H134.304V111.85H137.171V107.281Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M136.983 107.469V111.663H134.491V107.469H136.983ZM137.359 107.093H134.116V112.038H137.359V107.093Z",
    fill: "#263238"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M119.149 107.093H109.131V116.581H119.149V107.093Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M112.441 107.093V116.581",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M118.777 107.469V116.206H116.165V107.469H118.777ZM119.152 107.093H115.789V116.581H119.152V107.093Z",
    fill: "#263238"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M119.945 116.581H105.734V117.818H119.945V116.581Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 112.884H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 113.834H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 114.785H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 115.736H119.945",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M119.945 112.038H105.734V116.581H119.945V112.038Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M125.976 107.093H123.842V112.038H125.976V107.093Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M144.295 112.038H150.785V107.093H144.295V112.038Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M147.35 107.281H144.483V111.85H147.35V107.281Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M147.166 107.469V111.663H144.667V107.469H147.162M147.538 107.093H144.292V112.038H147.538V107.093Z",
    fill: "#263238"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M162.505 116.581H172.523V107.093H162.505V116.581Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M169.213 107.093V116.581",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M165.489 107.469V116.206H162.881V107.469H165.489ZM165.865 107.093H162.505V116.581H165.865V107.093Z",
    fill: "#263238"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M161.712 117.818H175.924V116.581H161.712V117.818Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 112.884H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 113.834H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 114.785H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 115.736H161.709",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M161.712 116.581H175.924V112.038H161.712V116.581Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M155.677 112.038H157.812V107.093H155.677V112.038Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M137.359 123.68H130.869V128.625H137.359V123.68Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M137.171 123.868H134.304V128.437H137.171V123.868Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M136.983 124.055V128.249H134.491V124.055H136.983ZM137.359 123.68H134.116V128.625H137.359V123.68Z",
    fill: "#263238"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M119.149 123.68H109.131V133.168H119.149V123.68Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M112.441 123.68V133.168",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M118.777 124.055V132.792H116.165V124.055H118.777ZM119.152 123.68H115.789V133.168H119.152V123.68Z",
    fill: "#263238"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M125.976 123.68H123.842V128.625H125.976V123.68Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M144.295 128.625H150.785V123.68H144.295V128.625Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M147.35 123.868H144.483V128.437H147.35V123.868Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M147.166 124.055V128.249H144.667V124.055H147.162M147.538 123.68H144.292V128.625H147.538V123.68Z",
    fill: "#263238"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M162.505 133.168H172.523V123.68H162.505V133.168Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M169.213 123.68V133.168",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M165.489 124.055V132.792H162.881V124.055H165.489ZM165.865 123.68H162.505V133.168H165.865V123.68Z",
    fill: "#263238"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M155.677 128.625H157.812V123.68H155.677V128.625Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M152.528 42.9827H129.125V47.9278H152.528V42.9827Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2173_7287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 42,
    width: 24,
    height: 6
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M152.528 42.9827H129.125V47.9278H152.528V42.9827Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2173_7287)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M152.532 42.9827H129.125V44.3993H152.532V42.9827Z",
    fill: "black"
  }))), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M152.528 42.9827H129.125V47.9278H152.528V42.9827Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M131.763 42.9827V47.9278",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M134.784 42.9827V47.9278",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M137.806 42.9827V47.9278",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M140.827 42.9827V47.9278",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M143.848 42.9827V47.9278",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M146.869 42.9827V47.9278",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M149.894 42.9827V47.9278",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M155.486 40.8033H126.172L130.317 35.7153H151.337L155.486 40.8033Z",
    fill: "#EB6502"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2173_7287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 35,
    width: 30,
    height: 6
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M155.486 40.8033H126.172L130.317 35.7153H151.337L155.486 40.8033Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2173_7287)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.486 40.8033H126.172L130.317 35.7153H151.337L155.486 40.8033Z",
    fill: "black"
  }))), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M155.486 40.8033H126.172L130.317 35.7153H151.337L155.486 40.8033Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M155.884 40.187H125.774V41.4158H155.884V40.187Z",
    fill: "#EB6502"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2173_7287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 40,
    width: 31,
    height: 2
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M155.884 40.187H125.774V41.4158H155.884V40.187Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2173_7287)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.884 40.187H125.774V41.4158H155.884V40.187Z",
    fill: "black"
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M155.884 40.187H125.774V41.4158H155.884V40.187Z",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.978 50.2615H134.168V49.3822H131.978V50.2615Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.732 51.2646H135.923V50.3853H133.732V51.2646Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.891 56.2212H142.082V55.3419H139.891V56.2212Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M138.794 57.3823H140.985V56.503H138.794V57.3823Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M130.884 65.2358H133.075V64.3565H130.884V65.2358Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M132.083 66.3293H134.273V65.45H132.083V66.3293Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.84 67.374H147.031V66.4947H144.84V67.374Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.683 68.5464H145.874V67.6671H143.683V68.5464Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.575 73.146H133.766V72.2667H131.575V73.146Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.338 65.2358H135.529V64.3565H133.338V65.2358Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.477 89.8679H140.286V90.7472H142.477V89.8679Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M132.83 88.8608H130.64V89.7401H132.83V88.8608Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.694 83.1565H133.503V84.0358H135.694V83.1565Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M136.787 81.9954H134.597V82.8747H136.787V81.9954Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.57 74.8933H141.379V75.7726H143.57V74.8933Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.371 73.7961H140.181V74.6754H142.371V73.7961Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M147.602 52.7793H145.411V53.6586H147.602V52.7793Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.759 51.6067H146.569V52.486H148.759V51.6067Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.106 71.3196H145.915V72.1989H148.106V71.3196Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.116 74.8933H138.925V75.7726H141.116V74.8933Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.127 83.6902H147.937V84.5695H150.127V83.6902Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.372 82.6831H146.182V83.5624H148.372V82.6831Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M151.972 122.447H149.781V123.327H151.972V122.447Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.774 121.354H148.583V122.233H150.774V121.354Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.883 121.812H131.692V122.691H133.883V121.812Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.04 120.64H132.849V121.519H135.04V120.64Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M151.281 114.537H149.09V115.416H151.281V114.537Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M149.518 122.447H147.328V123.327H149.518V122.447Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.106 122.503C141.236 122.481 143.431 122.481 145.494 122.503H139.106Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.499 96.688H137.689V95.8087H135.499V96.688Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.25 97.6951H139.44V96.8158H137.25V97.6951Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.281 103.399H144.472V102.52H142.281V103.399Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.184 116.209H143.375V115.33H141.184V116.209Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.401 110.163H136.592V109.284H134.401V110.163Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.604 111.257H137.794V110.378H135.604V111.257Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.866 113.729H132.056V112.85H129.866V113.729Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M136.855 110.163H139.046V109.284H136.855V110.163Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M146.05 119.039H148.241V118.16H146.05V119.039Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M147.253 117.949H149.443V117.07H147.253V117.949Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M139.459 124.649H141.65V123.77H139.459V124.649Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M138.302 123.477H140.492V122.598H138.302V123.477Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M148.504 119.039H150.695V118.16H148.504V119.039Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M142.477 96.5791H140.286V97.4584H142.477V96.5791Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M132.83 97.5862H130.64V98.4655H132.83V97.5862Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M134.822 102.174H132.631V103.054H134.822V102.174Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M135.916 103.339H133.725V104.218H135.916V103.339Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M138.189 115.372H135.998V116.251H138.189V115.372Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M136.99 116.465H134.8V117.344H136.99V116.465Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M131.966 105.947H129.775V106.826H131.966V105.947Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M135.735 115.372H133.544V116.251H135.735V115.372Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M150.127 102.757H147.937V103.636H150.127V102.757Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M148.372 103.764H146.182V104.643H148.372V103.764Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M133.503 52.7793H131.312V53.6586H133.503V52.7793Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149.721 49.5737H147.531V50.453H149.721V49.5737Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M151.082 63.4512H148.891V64.3305H151.082V63.4512Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149.879 64.5447H147.689V65.424H149.879V64.5447Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.771 51.1672H138.58V52.0465H140.771V51.1672Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.928 52.3396H139.737V53.2189H141.928V52.3396Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M151.281 71.906H149.09V72.7853H151.281V71.906Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M148.628 63.4512H146.437V64.3305H148.628V63.4512Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M132.83 70.4104H135.021V69.5311H132.83V70.4104Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M134.582 69.4033H136.772V68.524H134.582V69.4033Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M138.005 87.4592H140.196V86.5799H138.005V87.4592Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.184 71.9922H143.375V71.1129H141.184V71.9922Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M139.548 86.4939L141.737 86.5872L141.774 85.7087L139.586 85.6154L139.548 86.4939Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.459 85.6131L142.65 85.7007L142.685 84.8214L140.494 84.7337L140.459 85.6131Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.083 63.1052H142.274V62.2259H140.083V63.1052Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M138.925 61.9329H141.116V61.0536H138.925V61.9329Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M139.44 80.0742L141.629 80.1675L141.667 79.289L139.478 79.1957L139.44 80.0742Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.997 86.5959L144.186 86.6892L144.224 85.8107L142.035 85.7174L141.997 86.5959Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M120.734 55.7778V140.822",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M161.032 55.7778V140.822",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M148.929 36.8013H150.187",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M134.521 36.7825C138.219 36.7825 141.917 36.7825 145.614 36.7825",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M129.434 36.8013H133.278",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M137.189 37.8835H135.367",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M152.957 37.8835C149.394 37.8986 145.832 37.8986 142.27 37.8835",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M152.108 39.1311H152.957",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M138.501 39.1311H145.828",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M130.831 39.1311H137.355",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M127.532 39.1311H128.622",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M139.88 37.8835H140.477",
    stroke: "#263238",
    strokeWidth: 0.375772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M246.8 179.372H258.292",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M17.424 179.372H243.2",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7293 83.8388L64.9913 79.9814L59.1288 90.2221L65.8668 94.0794L71.7293 83.8388Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M60.604 87.6599L57.464 93.1439C57.3873 93.2787 57.3487 93.4317 57.3522 93.5867C57.3557 93.7417 57.4013 93.8928 57.484 94.0239L58.164 94.9759C58.4491 95.4262 58.6061 95.9457 58.618 96.4785C58.63 97.0113 58.4966 97.5373 58.232 97.9999L53.2 106C52.6716 106.925 52.4242 107.984 52.488 109.048L52.508 109.364C52.5119 109.425 52.5312 109.483 52.5643 109.534C52.5973 109.586 52.6428 109.627 52.6966 109.656C52.7503 109.684 52.8105 109.698 52.8713 109.697C52.9321 109.696 52.9916 109.679 53.044 109.648L53.388 109.448C54.2188 108.968 54.9086 108.279 55.388 107.448L59.812 98.9199C60.0759 98.4571 60.4614 98.0752 60.9267 97.8157C61.3921 97.5563 61.9195 97.4291 62.452 97.4479H63.488C63.6301 97.4518 63.7706 97.4165 63.894 97.346C64.0175 97.2754 64.1192 97.1723 64.188 97.0479L67.348 91.5239L60.604 87.6599Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinejoin: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6039 87.665L57.5872 92.9346L64.3252 96.7919L67.3419 91.5223L60.6039 87.665Z",
    fill: "white",
    stroke: "#263238",
    strokeLinejoin: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M60.232 88.3799L66.996 92.2519",
    stroke: "#263238",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M59.86 89.0239L66.628 92.8999",
    stroke: "#263238",
    strokeLinejoin: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M65.968 80.4319L65.2 81.7759",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M67.02 81.364L65.224 84.5",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M69.244 82.4399L68.56 83.6359",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M70.064 82.9719L68.864 85.0639",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3 159.7H78.884V180.652H94.3V159.7Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M94.16 165.152H89.232V177.476H94.16V165.152Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M78.88 163.128C78.88 163.128 75.916 168.728 77.456 172.108C78.552 174.508 83.172 176.2 87.156 173.04C91.14 169.88 91.156 162.612 91.156 162.612",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M91.092 163.344C91.0202 163.344 90.9491 163.331 90.8826 163.304C90.8161 163.277 90.7557 163.237 90.7048 163.186C90.6538 163.135 90.6134 163.075 90.5858 163.009C90.5582 162.943 90.544 162.872 90.544 162.8V161.648H91.64V162.8C91.64 162.872 91.6258 162.943 91.5982 163.009C91.5706 163.075 91.5302 163.135 91.4793 163.186C91.4283 163.237 91.3679 163.277 91.3014 163.304C91.235 163.331 91.1638 163.344 91.092 163.344Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M79.792 159.788V164.908C79.792 165.129 79.8797 165.34 80.0357 165.496C80.1917 165.652 80.4033 165.74 80.624 165.74C80.8447 165.74 81.0563 165.652 81.2123 165.496C81.3683 165.34 81.456 165.129 81.456 164.908V162.192C81.456 161.949 81.5525 161.716 81.7243 161.544C81.8961 161.372 82.1291 161.276 82.372 161.276C82.6153 161.276 82.8487 161.372 83.0211 161.544C83.1935 161.716 83.2909 161.949 83.292 162.192V162.764C83.292 162.902 83.3192 163.039 83.3721 163.166C83.4251 163.293 83.5026 163.409 83.6004 163.506C83.6981 163.604 83.8141 163.681 83.9417 163.733C84.0693 163.786 84.206 163.812 84.344 163.812C84.6219 163.812 84.8885 163.702 85.085 163.505C85.2816 163.308 85.392 163.042 85.392 162.764V161.744C85.392 161.602 85.4201 161.461 85.4746 161.33C85.5291 161.198 85.609 161.079 85.7097 160.979C85.8104 160.879 85.93 160.799 86.0615 160.745C86.193 160.691 86.3338 160.663 86.476 160.664H88.336C88.6228 160.664 88.8979 160.778 89.1011 160.98C89.3043 161.182 89.4189 161.457 89.42 161.744V162.108C89.42 162.189 89.452 162.266 89.509 162.323C89.566 162.38 89.6434 162.412 89.724 162.412C89.7642 162.412 89.8042 162.405 89.8416 162.39C89.8789 162.375 89.9129 162.353 89.9415 162.324C89.9702 162.296 89.993 162.262 90.0085 162.225C90.024 162.188 90.032 162.148 90.032 162.108V161.332C90.032 161.061 90.1395 160.802 90.3307 160.611C90.522 160.419 90.7815 160.312 91.052 160.312H92.568V160.4C92.568 160.612 92.6523 160.816 92.8023 160.966C92.9523 161.116 93.1558 161.2 93.368 161.2C93.5802 161.2 93.7837 161.116 93.9337 160.966C94.0837 160.816 94.168 160.612 94.168 160.4V159.7L79.792 159.788Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M111.677 174.598C112.65 170.44 110.068 166.281 105.91 165.308C101.752 164.335 97.5923 166.917 96.6194 171.075C95.6464 175.233 98.2284 179.392 102.386 180.365C106.544 181.338 110.704 178.756 111.677 174.598Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M106.548 179.981C110.485 178.328 112.337 173.796 110.683 169.858C109.03 165.921 104.498 164.07 100.56 165.723C96.6233 167.377 94.772 171.909 96.4254 175.846C98.0788 179.783 102.611 181.634 106.548 179.981Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M110.379 173.953C110.986 170.189 108.427 166.644 104.663 166.037C100.899 165.429 97.3547 167.988 96.747 171.752C96.1394 175.517 98.6983 179.061 102.463 179.668C106.227 180.276 109.771 177.717 110.379 173.953Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M252.5 59.0681C252.608 59.108 252.721 59.1283 252.836 59.1281C253.241 59.1065 253.626 58.947 253.928 58.6761C254.172 58.4561 254.288 58.2281 254.24 58.0521C254.227 58.0049 254.202 57.962 254.167 57.9282C254.132 57.8943 254.088 57.8708 254.04 57.8601C253.692 57.7561 252.932 58.0921 252.756 58.2601C252.572 58.4198 252.454 58.6421 252.424 58.8841L252.336 58.9561C252.354 58.8906 252.354 58.8215 252.336 58.7561C252.321 58.7188 252.298 58.6855 252.268 58.6585C252.238 58.6315 252.203 58.6115 252.164 58.6001L252.256 57.7001C252.326 57.7161 252.397 57.7242 252.468 57.7241C252.872 57.7016 253.255 57.5421 253.556 57.2721C253.8 57.0521 253.916 56.8281 253.868 56.6481C253.855 56.6009 253.83 56.558 253.795 56.5242C253.76 56.4903 253.716 56.4668 253.668 56.4561C253.32 56.3521 252.56 56.6881 252.384 56.8561L252.352 56.8921C252.298 56.6402 252.193 56.4019 252.044 56.1921C251.945 56.0268 251.792 55.9 251.612 55.8321C251.782 55.734 251.937 55.6113 252.072 55.4681C252.292 55.2281 252.384 54.9881 252.316 54.8161C252.298 54.7704 252.268 54.7304 252.229 54.7002C252.191 54.6699 252.145 54.6506 252.096 54.6441C251.74 54.5761 251.02 54.9881 250.86 55.1641C250.771 55.26 250.702 55.3728 250.658 55.4958C250.613 55.6187 250.593 55.7494 250.6 55.8801L250.332 56.2281V53.8281C250.34 53.8047 250.34 53.7794 250.332 53.7561V53.1601L250.692 52.8761C250.768 52.8965 250.846 52.9072 250.924 52.9081C251.366 52.8752 251.778 52.6715 252.072 52.3401C252.292 52.0961 252.384 51.8601 252.316 51.6881C252.298 51.6422 252.269 51.602 252.23 51.5717C252.191 51.5414 252.145 51.5222 252.096 51.5161C251.638 51.5473 251.203 51.7302 250.86 52.0361C250.692 52.2163 250.597 52.4534 250.596 52.7001L250.332 52.9081V51.5201H250.416C250.857 51.487 251.267 51.2832 251.56 50.9521C251.656 50.8753 251.729 50.7745 251.773 50.6598C251.816 50.5452 251.829 50.421 251.808 50.3001C251.79 50.2544 251.76 50.2144 251.721 50.1842C251.683 50.1539 251.637 50.1346 251.588 50.1281C251.236 50.0601 250.512 50.4761 250.352 50.6521L250.324 50.6881C250.245 50.4435 250.117 50.2176 249.948 50.0241C249.728 49.7761 249.504 49.6641 249.324 49.7121C249.277 49.7251 249.234 49.7506 249.201 49.7858C249.167 49.8209 249.143 49.8646 249.132 49.9121C249.028 50.2561 249.36 51.0161 249.532 51.1961C249.688 51.3776 249.906 51.4945 250.144 51.5241V53.5841L249.896 53.4001C249.896 53.152 249.801 52.9133 249.632 52.7321C249.29 52.4251 248.855 52.2407 248.396 52.2081C248.347 52.2146 248.301 52.2339 248.263 52.2642C248.224 52.2944 248.194 52.3344 248.176 52.3801C248.108 52.5521 248.2 52.7801 248.42 53.0321C248.713 53.3649 249.126 53.5689 249.568 53.6001C249.644 53.6006 249.719 53.5912 249.792 53.5721L250.144 53.8321V56.5761L249.892 56.3521C249.885 56.2115 249.845 56.0745 249.776 55.9521C249.832 55.8781 249.868 55.7916 249.882 55.7001C249.896 55.6087 249.887 55.5152 249.856 55.4281C249.836 55.3836 249.803 55.3459 249.762 55.3196C249.721 55.2933 249.673 55.2796 249.624 55.2801C249.454 55.2831 249.287 55.3299 249.14 55.4161C248.961 55.3201 248.768 55.2527 248.568 55.2161C248.746 55.0958 248.903 54.9472 249.032 54.7761C249.228 54.5121 249.292 54.2681 249.208 54.1041C249.185 54.0607 249.152 54.0241 249.11 53.9981C249.069 53.9721 249.021 53.9576 248.972 53.9561C248.616 53.9241 247.94 54.4121 247.796 54.6041C247.789 54.6169 247.781 54.629 247.772 54.6401C247.667 54.4056 247.516 54.1947 247.328 54.0201C247.088 53.8001 246.852 53.7081 246.68 53.7761C246.634 53.7927 246.594 53.8217 246.564 53.8598C246.533 53.8979 246.514 53.9437 246.508 53.9921C246.536 54.4516 246.718 54.8883 247.024 55.2321C247.193 55.3864 247.408 55.4794 247.636 55.4961L247.848 57.5281L247.612 57.3481C247.579 57.1149 247.462 56.9017 247.284 56.7481C246.914 56.4731 246.461 56.3321 246 56.3481C245.952 56.3588 245.909 56.3823 245.873 56.4162C245.838 56.45 245.813 56.4929 245.8 56.5401C245.752 56.7161 245.868 56.9401 246.112 57.1641C246.415 57.4283 246.798 57.582 247.2 57.6001C247.322 57.6019 247.443 57.5787 247.556 57.5321L247.872 57.7721L248.168 60.6241L247.928 60.3761C247.908 60.1168 247.787 59.8756 247.592 59.7041C247.22 59.4319 246.769 59.2912 246.308 59.3041C246.26 59.3163 246.217 59.3409 246.182 59.3753C246.147 59.4097 246.121 59.4527 246.108 59.5001C246.06 59.6761 246.172 59.9001 246.42 60.1201C246.719 60.3935 247.103 60.5547 247.508 60.5761C247.607 60.5744 247.706 60.5582 247.8 60.5281L248.2 60.9281L248.38 62.6521C248.333 62.6601 248.29 62.6803 248.253 62.7104C248.217 62.7406 248.189 62.7798 248.172 62.8241C248.154 62.8868 248.154 62.9533 248.172 63.0161C248.111 62.8815 248.023 62.7615 247.912 62.6641C247.541 62.3908 247.089 62.25 246.628 62.2641C246.58 62.2753 246.537 62.2997 246.502 62.3343C246.468 62.3689 246.443 62.4124 246.432 62.4601C246.384 62.6361 246.496 62.8601 246.74 63.0801C247.042 63.351 247.427 63.5105 247.832 63.5321C247.941 63.5313 248.049 63.5124 248.152 63.4761L248.516 63.8041L248.684 65.4281L248.44 65.1681C248.433 65.0373 248.4 64.9093 248.342 64.7918C248.284 64.6742 248.203 64.5696 248.104 64.4841C247.733 64.2114 247.281 64.0706 246.82 64.0841C246.772 64.0963 246.729 64.1208 246.694 64.1553C246.659 64.1897 246.633 64.2327 246.62 64.2801C246.572 64.4561 246.688 64.6801 246.932 64.9001C247.233 65.1701 247.616 65.3296 248.02 65.3521C248.116 65.3517 248.212 65.3369 248.304 65.3081L248.704 65.7481L248.78 66.5081C248.653 66.4588 248.516 66.441 248.38 66.4561C248.331 66.4626 248.285 66.4819 248.247 66.5122C248.208 66.5424 248.178 66.5824 248.16 66.6281C248.139 66.6944 248.132 66.7647 248.141 66.8339C248.15 66.9031 248.174 66.9694 248.212 67.0281C247.871 66.817 247.473 66.7151 247.072 66.7361C247.024 66.7468 246.981 66.7703 246.945 66.8042C246.91 66.838 246.885 66.8809 246.872 66.9281C246.824 67.1081 246.936 67.3281 247.184 67.5521C247.484 67.823 247.868 67.9825 248.272 68.0041C248.37 68.0024 248.467 67.9862 248.56 67.9561L248.96 68.3881L248.988 68.6561C248.966 68.6749 248.948 68.698 248.936 68.7241C248.904 68.8247 248.897 68.9321 248.918 69.0358C248.939 69.1395 248.987 69.236 249.056 69.3161L249.104 69.7681L248.868 69.5721C248.838 69.3313 248.72 69.1103 248.536 68.9521C248.36 68.7961 247.6 68.4601 247.256 68.5521C247.208 68.5628 247.165 68.5863 247.129 68.6202C247.094 68.654 247.069 68.6969 247.056 68.7441C247.008 68.9241 247.12 69.1441 247.368 69.3681C247.668 69.6395 248.052 69.7992 248.456 69.8201C248.571 69.8203 248.684 69.8 248.792 69.7601L249.132 70.0401L249.248 71.1281H248.528L248.808 76.7681H251.152L251.428 71.1281H250.828L250.9 70.4561C250.907 70.4424 250.91 70.4273 250.91 70.4121C250.91 70.3968 250.907 70.3818 250.9 70.3681L250.976 69.6161L251.468 69.0961C251.559 69.1278 251.655 69.1441 251.752 69.1441C252.156 69.1225 252.54 68.963 252.84 68.6921C253.088 68.4721 253.2 68.2441 253.152 68.0681C253.141 68.0208 253.117 67.9776 253.082 67.9436C253.047 67.9096 253.004 67.8862 252.956 67.8761C252.734 67.8431 252.507 67.8707 252.3 67.9561C252.304 67.9072 252.297 67.8581 252.28 67.8121C252.262 67.7662 252.233 67.726 252.194 67.6957C252.155 67.6654 252.109 67.6462 252.06 67.6401C251.736 67.6448 251.421 67.7435 251.152 67.9241V67.9041L251.364 65.8641C251.37 65.8445 251.37 65.8236 251.364 65.8041L251.464 64.8161L251.956 64.2961C252.048 64.3259 252.144 64.3421 252.24 64.3441C252.645 64.3227 253.029 64.1615 253.328 63.8881C253.576 63.6721 253.688 63.4441 253.64 63.2681C253.628 63.2203 253.602 63.1769 253.567 63.1423C253.532 63.1078 253.488 63.0835 253.44 63.0721C252.981 63.0586 252.53 63.1994 252.16 63.4721C252.061 63.5574 251.98 63.662 251.922 63.7796C251.864 63.8972 251.831 64.0252 251.824 64.1561L251.48 64.5161L251.668 62.7201L251.716 62.6721C251.821 62.5973 251.917 62.5114 252.004 62.4161C252.065 62.3506 252.12 62.2796 252.168 62.2041C252.257 62.2329 252.35 62.2478 252.444 62.2481C252.848 62.2265 253.232 62.067 253.532 61.7961C253.78 61.5761 253.892 61.3521 253.844 61.1721C253.832 61.1244 253.807 61.0811 253.772 61.0472C253.736 61.0132 253.692 60.9899 253.644 60.9801C253.3 60.8761 252.54 61.2121 252.36 61.3801C252.274 61.4576 252.202 61.5497 252.148 61.6521C252.112 61.6301 252.073 61.6138 252.032 61.6041C251.945 61.5889 251.855 61.5889 251.768 61.6041L251.992 59.4481L252.5 59.0681ZM251.824 59.8281L251.732 59.6881C251.771 59.6637 251.808 59.637 251.844 59.6081L251.824 59.8281ZM251.22 65.6361L251.024 65.4681C251.051 65.2182 250.981 64.9676 250.828 64.7681C250.686 64.6109 250.522 64.476 250.34 64.3681V63.4801L250.74 62.9401C250.8 62.9459 250.86 62.9459 250.92 62.9401C251.09 62.9373 251.257 62.9006 251.412 62.8321L251.488 62.9201L251.22 65.6361ZM249.116 67.7841C249.258 67.8421 249.41 67.8733 249.564 67.8761C249.623 67.8751 249.682 67.8684 249.74 67.8561L250.14 68.3841V69.0161C249.874 68.7851 249.548 68.6352 249.2 68.5841L249.116 67.7841ZM250.14 68.0601L249.888 67.7281C249.9 67.4827 249.82 67.2415 249.664 67.0521C249.804 67.181 249.965 67.2852 250.14 67.3601V68.0601ZM250.34 62.3921C250.429 62.4586 250.526 62.5149 250.628 62.5601C250.61 62.6413 250.603 62.7249 250.608 62.8081L250.34 63.1601V62.3921ZM249.888 59.3081C249.928 59.2647 249.965 59.2193 250 59.1721C250.054 59.1005 250.1 59.0242 250.14 58.9441V59.7441L249.888 59.4201C249.893 59.3829 249.893 59.3452 249.888 59.3081ZM248.74 59.8561H248.824C249.116 59.8472 249.397 59.7432 249.624 59.5601C249.671 59.5638 249.717 59.5638 249.764 59.5601L250.164 60.0761V60.6561C250.114 60.6055 250.047 60.5755 249.976 60.5721C249.596 60.6271 249.252 60.8244 249.012 61.1241C248.932 61.2274 248.874 61.346 248.842 61.4726C248.809 61.5992 248.803 61.731 248.824 61.8601L248.564 62.2841L248.376 60.4881L248.74 59.8561ZM249.888 63.8121C249.88 63.5783 249.787 63.3553 249.628 63.1841C249.326 62.9291 248.966 62.7507 248.58 62.6641V62.5881L248.952 61.9801H249.048C249.302 61.9726 249.547 61.8812 249.744 61.7201C249.784 61.8111 249.835 61.897 249.896 61.9761C249.968 62.0685 250.047 62.1554 250.132 62.2361V64.0441L249.888 63.8121ZM249.44 66.8001L249.528 66.9041L249.424 66.8281L249.44 66.8001ZM250.46 69.3721L250.748 69.0081H250.868L250.748 70.1441L250.556 69.9241C250.577 69.7399 250.544 69.5536 250.46 69.3881V69.3721ZM250.968 68.0721C250.933 68.0974 250.899 68.1255 250.868 68.1561C250.779 68.2505 250.711 68.3619 250.666 68.4836C250.621 68.6052 250.602 68.7346 250.608 68.8641L250.348 69.1921V67.4201C250.428 67.4421 250.51 67.4542 250.592 67.4561H250.676L250.988 67.9641L250.968 68.0721ZM250.34 60.0721C250.35 60.0565 250.355 60.0385 250.355 60.0201C250.355 60.0016 250.35 59.9836 250.34 59.9681V59.1081C250.439 59.2141 250.549 59.3093 250.668 59.3921C250.617 59.5189 250.597 59.6559 250.608 59.7921L250.34 60.1441V60.0721ZM250.74 55.9481C250.799 55.9606 250.86 55.9673 250.92 55.9681C251.03 55.9681 251.139 55.9519 251.244 55.9201C251.181 56.375 251.271 56.8381 251.5 57.2361C251.627 57.4293 251.818 57.5712 252.04 57.6361L251.944 58.5481C251.749 58.5779 251.56 58.6387 251.384 58.7281C251.093 58.4416 250.729 58.2397 250.332 58.1441V56.5201L250.74 55.9481ZM250.128 58.1801C250.084 58.204 250.048 58.2401 250.024 58.2841C250.024 58.2841 250.024 58.3161 250.004 58.3361C249.98 58.3315 249.956 58.3315 249.932 58.3361C249.738 58.3419 249.548 58.3999 249.384 58.5041C249.091 58.292 248.741 58.1722 248.38 58.1601C248.331 58.1662 248.285 58.1854 248.246 58.2157C248.208 58.246 248.178 58.2862 248.16 58.3321C248.092 58.5041 248.184 58.7321 248.404 58.9841C248.477 59.0597 248.554 59.1305 248.636 59.1961C248.564 59.3606 248.54 59.5425 248.568 59.7201L248.308 60.1201L248.016 57.3401L248.388 56.7361H248.472C248.724 56.726 248.967 56.6426 249.172 56.4961C249.29 56.5338 249.412 56.554 249.536 56.5561C249.621 56.5572 249.706 56.5465 249.788 56.5241L250.1 56.8041L250.128 58.1801ZM247.828 55.4201C247.935 55.4187 248.042 55.4012 248.144 55.3681C248.129 55.4865 248.144 55.6069 248.189 55.7176C248.234 55.8282 248.307 55.9255 248.4 56.0001C248.278 56.1956 248.23 56.4282 248.264 56.6561L248.004 57.0561L247.836 55.4561L247.828 55.4201ZM248.38 63.4201L248.22 63.2761C248.218 63.2354 248.211 63.1952 248.2 63.1561C248.25 63.2663 248.317 63.3676 248.4 63.4561L248.38 63.4201ZM248.68 63.6921C248.93 63.889 249.234 64.0036 249.552 64.0201C249.637 64.0199 249.722 64.0078 249.804 63.9841L250.008 64.1721C249.892 64.1153 249.765 64.0866 249.636 64.0881C249.588 64.0894 249.54 64.1039 249.5 64.13C249.459 64.1561 249.426 64.1927 249.404 64.2361C249.32 64.4001 249.404 64.6361 249.58 64.9081C249.728 65.1058 249.912 65.2729 250.124 65.4001C249.88 65.5244 249.66 65.6894 249.472 65.8881C249.473 65.8973 249.473 65.9068 249.472 65.9161C249.423 65.9176 249.375 65.9321 249.334 65.9581C249.293 65.9841 249.259 66.0207 249.236 66.0641C249.206 66.1467 249.197 66.2353 249.209 66.3223C249.221 66.4094 249.253 66.4923 249.304 66.5641C249.302 66.584 249.302 66.6041 249.304 66.6241L249.252 66.7081C249.169 66.6583 249.082 66.6154 248.992 66.5801L248.68 63.6921ZM248.68 67.7841C248.673 67.6756 248.649 67.5689 248.608 67.4681C248.694 67.5362 248.785 67.5977 248.88 67.6521L248.924 68.0521L248.68 67.7841ZM249.284 69.5721C249.508 69.809 249.798 69.9734 250.116 70.0441V71.1161H249.444L249.284 69.5721ZM250.316 71.1161V70.0601H250.384L250.696 70.4201L250.624 71.1241L250.316 71.1161ZM251.044 68.9961C251.151 68.9826 251.256 68.9557 251.356 68.9161L251.016 69.2761L251.044 68.9961ZM250.804 67.3001C250.823 67.171 250.816 67.0396 250.783 66.9133C250.751 66.7871 250.694 66.6684 250.616 66.5641C250.556 66.4909 250.488 66.4251 250.412 66.3681C250.517 66.2758 250.614 66.1741 250.7 66.0641C250.804 65.9337 250.876 65.78 250.908 65.6161L251.172 65.8361L250.988 67.6041L250.804 67.3001ZM251.156 61.8321C251.144 61.808 251.129 61.7852 251.112 61.7641C250.886 61.5257 250.613 61.3353 250.312 61.2041V60.4481L250.712 59.9081C250.772 59.9139 250.832 59.9139 250.892 59.9081C251.113 59.9015 251.33 59.8426 251.524 59.7361L251.752 60.0921L251.596 61.5961C251.456 61.6746 251.324 61.7656 251.2 61.8681L251.156 61.8321Z",
    fill: "#263238"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M255.804 63.8201H265.356",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M255.804 65.8481H265.356",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M255.804 67.8721H265.356",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M255.804 90.22H265.356",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M255.804 92.248H265.356",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M255.804 94.272H265.356",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M243.952 83.0162C244.344 83.1176 244.748 83.1621 245.152 83.1482C245.152 83.1482 244.968 82.5842 244.952 82.5522C244.76 82.1522 244.152 81.5002 243.676 81.5682C243.595 81.581 243.518 81.6107 243.45 81.6553C243.381 81.7 243.323 81.7586 243.279 81.8274C243.235 81.8961 243.206 81.9734 243.193 82.0542C243.181 82.135 243.186 82.2174 243.208 82.2962C243.272 82.4634 243.371 82.6146 243.5 82.739C243.628 82.8634 243.783 82.958 243.952 83.0162Z",
    fill: "#263238"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M255.256 80.076C254.768 80.024 254.188 80.6961 254.008 81.0961C254.008 81.1321 253.812 81.7 253.824 81.7L253.528 82.044C253.34 82.28 253.128 82.548 252.912 82.844C252.677 83.1713 252.463 83.5133 252.272 83.868C252.051 84.2607 251.868 84.6731 251.724 85.1C251.724 84.956 251.724 84.5521 251.724 84.5201C251.668 84.088 251.3 83.276 250.816 83.188C250.735 83.1756 250.653 83.1803 250.574 83.2018C250.496 83.2233 250.423 83.2611 250.36 83.3128C250.297 83.3645 250.245 83.429 250.209 83.5019C250.172 83.5748 250.152 83.6546 250.148 83.736C250.155 83.9125 250.2 84.0854 250.28 84.2429C250.36 84.4003 250.473 84.5385 250.612 84.648C250.954 84.8688 251.325 85.0385 251.716 85.1521C251.579 85.5886 251.471 86.0335 251.392 86.4841C251.344 86.7481 251.308 87.0161 251.272 87.2841C251.272 87.1561 251.272 87.048 251.272 87.032C251.216 86.596 250.872 85.788 250.368 85.7C250.287 85.687 250.205 85.6911 250.126 85.7121C250.047 85.7331 249.974 85.7704 249.91 85.8218C249.847 85.8731 249.795 85.9373 249.758 86.01C249.721 86.0828 249.7 86.1625 249.696 86.244C249.703 86.4209 249.749 86.594 249.83 86.7514C249.911 86.9088 250.025 87.0469 250.164 87.156C250.492 87.3744 250.853 87.5403 251.232 87.648C251.232 87.752 251.208 87.856 251.192 87.956C251.136 88.452 251.08 88.944 251.008 89.424C250.984 89.596 250.952 89.7601 250.924 89.9281C250.924 89.8161 250.924 89.7241 250.924 89.7081C250.868 89.2721 250.524 88.4641 250.02 88.376C249.939 88.3636 249.857 88.3683 249.778 88.3898C249.699 88.4112 249.626 88.449 249.562 88.5007C249.499 88.5523 249.447 88.6167 249.41 88.6896C249.373 88.7626 249.352 88.8424 249.348 88.924C249.354 89.1005 249.4 89.2734 249.481 89.4303C249.561 89.5873 249.676 89.7245 249.816 89.832C250.135 90.0479 250.486 90.2113 250.856 90.316C250.82 90.488 250.784 90.6561 250.74 90.8201C250.696 90.984 250.688 91.036 250.648 91.148C250.608 91.26 250.58 91.364 250.544 91.468C250.472 91.672 250.396 91.868 250.32 92.08L250.16 92.48C250.188 92.312 250.232 91.9801 250.232 91.9521C250.228 91.5653 250.123 91.1862 249.928 90.8521C249.934 90.8096 249.934 90.7665 249.928 90.724C249.918 90.6431 249.892 90.5652 249.85 90.4953C249.808 90.4254 249.752 90.3653 249.685 90.3188C249.618 90.2723 249.542 90.2405 249.462 90.2255C249.382 90.2106 249.299 90.2128 249.22 90.232C248.744 90.356 248.444 91.1921 248.42 91.6281C248.42 91.6561 248.42 91.936 248.448 92.116C248.424 92.012 248.404 91.912 248.376 91.804C248.328 91.596 248.272 91.4041 248.212 91.1641C248.18 91.0561 248.148 90.948 248.112 90.836C248.076 90.724 248.036 90.616 248 90.504C247.904 90.248 247.796 89.992 247.684 89.736C248.068 89.6591 248.437 89.5243 248.78 89.336C248.928 89.2384 249.052 89.1092 249.144 88.9577C249.236 88.8062 249.294 88.6363 249.312 88.46C249.314 88.3787 249.299 88.2978 249.267 88.2227C249.236 88.1475 249.189 88.0798 249.13 88.024C249.071 87.9682 249 87.9254 248.924 87.8985C248.847 87.8717 248.765 87.8613 248.684 87.868C248.196 87.92 247.772 88.6961 247.684 89.1281C247.684 89.1561 247.648 89.472 247.636 89.644C247.564 89.492 247.496 89.3401 247.42 89.1841C247.204 88.7441 246.968 88.308 246.736 87.868C246.664 87.736 246.596 87.6 246.524 87.468C246.922 87.3875 247.305 87.2458 247.66 87.048C247.807 86.95 247.931 86.8213 248.024 86.6708C248.116 86.5202 248.175 86.3515 248.196 86.176C248.198 86.0945 248.183 86.0135 248.151 85.9382C248.12 85.8628 248.073 85.7949 248.014 85.7388C247.955 85.6826 247.885 85.6395 247.808 85.6122C247.731 85.5848 247.649 85.5739 247.568 85.58C247.076 85.632 246.652 86.412 246.564 86.844C246.564 86.876 246.516 87.328 246.512 87.444C246.36 87.148 246.208 86.8521 246.072 86.5521C245.884 86.1513 245.724 85.7384 245.592 85.316C245.991 85.2325 246.375 85.0895 246.732 84.892C246.88 84.7952 247.005 84.6668 247.098 84.5161C247.19 84.3653 247.248 84.1959 247.268 84.0201C247.271 83.9383 247.256 83.857 247.225 83.7814C247.194 83.7058 247.147 83.6376 247.088 83.5813C247.028 83.5251 246.958 83.482 246.881 83.4548C246.803 83.4277 246.721 83.4172 246.64 83.424C246.152 83.476 245.728 84.2561 245.636 84.6841C245.636 84.7201 245.588 85.2081 245.584 85.2961L245.56 85.224C245.437 84.7966 245.354 84.3588 245.312 83.916C245.284 83.672 245.272 83.4361 245.264 83.2081C245.662 83.1687 246.051 83.0702 246.42 82.916C246.576 82.8364 246.713 82.7235 246.821 82.5852C246.929 82.447 247.005 82.2869 247.044 82.116C247.055 82.0351 247.049 81.9527 247.027 81.8742C247.004 81.7957 246.965 81.7229 246.912 81.6606C246.859 81.5983 246.794 81.5479 246.72 81.5126C246.646 81.4774 246.566 81.4581 246.484 81.456C245.992 81.456 245.488 82.18 245.352 82.6C245.352 82.62 245.296 82.86 245.26 83.036C245.26 82.932 245.26 82.824 245.26 82.724C245.26 82.356 245.284 82.012 245.308 81.712C245.308 81.54 245.34 81.388 245.356 81.244C245.691 81.0251 245.989 80.7552 246.24 80.444C246.343 80.3 246.413 80.135 246.445 79.9607C246.477 79.7864 246.47 79.6072 246.424 79.436C246.397 79.3591 246.354 79.2888 246.297 79.2297C246.241 79.1707 246.173 79.1241 246.097 79.0932C246.022 79.0622 245.941 79.0475 245.859 79.0501C245.778 79.0527 245.697 79.0724 245.624 79.1081C245.188 79.3361 245.072 80.212 245.144 80.648C245.144 80.684 245.316 81.2561 245.324 81.2521C245.324 81.3881 245.284 81.54 245.268 81.7C245.24 82.004 245.208 82.344 245.2 82.716C245.184 83.1162 245.194 83.517 245.228 83.916C245.262 84.3647 245.337 84.8092 245.452 85.244C245.376 85.124 245.148 84.788 245.128 84.768C244.84 84.436 244.088 83.9681 243.636 84.1521C243.562 84.1865 243.496 84.236 243.442 84.2975C243.388 84.3591 243.348 84.4312 243.324 84.5092C243.3 84.5872 243.292 84.6694 243.302 84.7505C243.312 84.8317 243.338 84.9098 243.38 84.98C243.482 85.1247 243.615 85.2449 243.77 85.332C243.924 85.4192 244.095 85.4711 244.272 85.4841C244.679 85.4805 245.083 85.4171 245.472 85.2961C245.598 85.7369 245.755 86.1685 245.94 86.588C246.044 86.832 246.16 87.076 246.276 87.3201C246.208 87.2161 246.144 87.124 246.132 87.112C245.844 86.78 245.096 86.312 244.644 86.5C244.57 86.5341 244.503 86.5834 244.449 86.6447C244.395 86.7061 244.354 86.7781 244.33 86.8562C244.305 86.9342 244.297 87.0166 244.307 87.0979C244.316 87.1792 244.342 87.2576 244.384 87.3281C244.487 87.4719 244.62 87.5914 244.774 87.6778C244.928 87.7643 245.1 87.8156 245.276 87.8281C245.671 87.8295 246.064 87.7688 246.44 87.648L246.58 87.9281C246.8 88.3721 247.024 88.816 247.232 89.256C247.304 89.408 247.372 89.5641 247.44 89.72C247.376 89.628 247.324 89.5521 247.312 89.5401C247.024 89.2081 246.276 88.7401 245.824 88.9281C245.75 88.9621 245.683 89.0114 245.629 89.0727C245.575 89.1341 245.534 89.2061 245.51 89.2842C245.485 89.3622 245.477 89.4446 245.487 89.5259C245.496 89.6072 245.522 89.6856 245.564 89.756C245.667 89.8999 245.8 90.0194 245.954 90.1058C246.108 90.1923 246.28 90.2436 246.456 90.256C246.84 90.2596 247.222 90.2029 247.588 90.088C247.652 90.248 247.716 90.412 247.772 90.568C247.828 90.724 247.848 90.78 247.876 90.892C247.904 91.004 247.936 91.1121 247.968 91.22C248.016 91.432 248.072 91.6481 248.116 91.8521C248.148 91.9961 248.172 92.1321 248.204 92.2521C248.132 92.0961 247.988 91.796 247.972 91.772C247.736 91.4 247.068 90.8201 246.592 90.9401C246.511 90.9622 246.436 91.0016 246.371 91.0556C246.307 91.1096 246.254 91.1769 246.218 91.2528C246.182 91.3288 246.163 91.4117 246.162 91.4957C246.161 91.5798 246.178 91.6632 246.212 91.7401C246.292 91.8961 246.405 92.033 246.543 92.1414C246.682 92.2498 246.841 92.3271 247.012 92.368C247.409 92.4316 247.815 92.4316 248.212 92.368C248.26 92.596 248.3 92.8201 248.34 93.0321C248.396 93.3481 248.44 93.6401 248.48 93.9081H248V99.232H250.116V93.936H249.836C249.92 93.744 250.008 93.536 250.096 93.324C250.184 93.112 250.28 92.8681 250.372 92.6281C250.765 92.7176 251.17 92.7486 251.572 92.72C251.747 92.6941 251.914 92.6297 252.062 92.5315C252.209 92.4333 252.333 92.3037 252.424 92.1521C252.46 92.0789 252.48 91.999 252.483 91.9177C252.485 91.8363 252.471 91.7552 252.44 91.6798C252.41 91.6043 252.364 91.5361 252.305 91.4797C252.246 91.4232 252.177 91.3797 252.1 91.3521C251.636 91.1921 250.924 91.724 250.664 92.076C250.664 92.076 250.508 92.34 250.42 92.4761L250.532 92.18C250.604 91.976 250.672 91.7801 250.748 91.5521L250.844 91.2281C250.88 91.1201 250.904 91 250.932 90.888C250.996 90.62 251.048 90.348 251.092 90.088C251.456 90.2325 251.841 90.3201 252.232 90.348C252.409 90.3489 252.584 90.3106 252.744 90.236C252.905 90.1613 253.047 90.052 253.16 89.916C253.207 89.849 253.239 89.773 253.254 89.6928C253.269 89.6126 253.268 89.5301 253.249 89.4505C253.231 89.371 253.196 89.2962 253.147 89.231C253.098 89.1658 253.035 89.1117 252.964 89.072C252.528 88.848 251.744 89.264 251.432 89.572C251.432 89.572 251.216 89.84 251.108 89.972C251.136 89.808 251.16 89.64 251.184 89.472C251.244 88.984 251.288 88.4881 251.336 87.9961L251.384 87.544C251.768 87.6958 252.172 87.7888 252.584 87.8201C252.761 87.8188 252.936 87.7792 253.096 87.7039C253.256 87.6286 253.398 87.5195 253.512 87.3841C253.559 87.3173 253.591 87.2416 253.606 87.1617C253.621 87.0818 253.62 86.9996 253.601 86.9204C253.583 86.8412 253.548 86.7667 253.499 86.7019C253.449 86.637 253.387 86.5833 253.316 86.544C252.88 86.316 252.116 86.7321 251.784 87.0401C251.76 87.0641 251.476 87.42 251.408 87.516C251.444 87.184 251.48 86.8521 251.532 86.5281C251.596 86.0899 251.691 85.6568 251.816 85.232C252.2 85.383 252.605 85.476 253.016 85.5081C253.193 85.5089 253.368 85.4706 253.528 85.396C253.689 85.3213 253.831 85.212 253.944 85.076C253.991 85.009 254.023 84.9329 254.038 84.8528C254.053 84.7726 254.052 84.6901 254.033 84.6105C254.015 84.531 253.98 84.4562 253.931 84.391C253.882 84.3258 253.819 84.2717 253.748 84.232C253.312 84.008 252.528 84.42 252.216 84.732C252.192 84.756 251.884 85.132 251.816 85.212C251.816 85.188 251.816 85.16 251.836 85.136C251.969 84.7121 252.141 84.3012 252.348 83.9081C252.46 83.6881 252.58 83.488 252.7 83.292C253.053 83.4805 253.432 83.6153 253.824 83.692C254 83.7101 254.177 83.6898 254.344 83.6325C254.512 83.5751 254.664 83.4822 254.792 83.36C254.846 83.2987 254.886 83.2267 254.91 83.1489C254.934 83.071 254.942 82.9889 254.933 82.9079C254.923 82.8269 254.897 82.7487 254.856 82.6785C254.814 82.6082 254.758 82.5474 254.692 82.5C254.292 82.228 253.456 82.556 253.092 82.832C253.092 82.832 252.9 83.016 252.776 83.144L252.944 82.8841C253.148 82.5761 253.344 82.3041 253.544 82.0641C253.648 81.9321 253.748 81.812 253.844 81.7C254.241 81.7042 254.636 81.6476 255.016 81.532C255.181 81.4674 255.329 81.3677 255.451 81.2399C255.574 81.1122 255.667 80.9593 255.724 80.792C255.743 80.7141 255.746 80.6331 255.733 80.5539C255.719 80.4748 255.69 80.3993 255.646 80.3321C255.602 80.2649 255.545 80.2075 255.478 80.1634C255.411 80.1194 255.335 80.0896 255.256 80.076ZM249.844 93.2C249.728 93.464 249.62 93.7041 249.516 93.9281H248.8C248.752 93.6481 248.696 93.3361 248.628 92.9961C248.584 92.7641 248.528 92.5201 248.472 92.2641C248.703 92.1751 248.928 92.0695 249.144 91.948C249.44 92.2027 249.77 92.4154 250.124 92.58C250 92.8 249.928 93.012 249.844 93.2Z",
    fill: "#263238"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M252.68 83.2C252.68 83.2 252.836 82.628 252.844 82.588C252.904 82.156 252.764 81.28 252.32 81.064C252.245 81.0288 252.163 81.0101 252.081 81.0091C251.998 81.0081 251.916 81.0248 251.84 81.0581C251.764 81.0915 251.696 81.1407 251.641 81.2024C251.586 81.2641 251.545 81.3369 251.52 81.416C251.479 81.5877 251.476 81.7664 251.512 81.9392C251.548 82.1121 251.622 82.2749 251.728 82.416C252.004 82.7236 252.325 82.9878 252.68 83.2Z",
    fill: "#263238"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0128 26.2897L40.3408 27.4302L44.8339 77.3542L57.5059 76.2137L53.0128 26.2897Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.00404,
    strokeMiterlimit: 10
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2577 28.2166L41.918 29.0403L42.7417 38.38L52.0814 37.5563L51.2577 28.2166Z",
    fill: "#EB6502"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M51.2577 28.2166L41.918 29.0403L42.7417 38.38L52.0814 37.5563L51.2577 28.2166Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3369 40.4583L42.9971 41.282L43.8208 50.6217L53.1606 49.798L52.3369 40.4583Z",
    fill: "#EB6502"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M52.3369 40.4583L42.9971 41.282L43.8208 50.6217L53.1606 49.798L52.3369 40.4583Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4163 52.7041L44.0766 53.5278L44.9003 62.8676L54.24 62.0439L53.4163 52.7041Z",
    fill: "#EB6502"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.4163 52.7041L44.0766 53.5278L44.9003 62.8676L54.24 62.0439L53.4163 52.7041Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4958 64.9458L45.1561 65.7695L45.9798 75.1093L55.3195 74.2856L54.4958 64.9458Z",
    fill: "#EB6502"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5155 27.8051L55.155 25.0127L44.1539 73.7095L56.5144 76.5019L67.5155 27.8051Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8219 29.2785L56.6334 27.2158L54.5707 36.4043L63.7592 38.467L65.8219 29.2785Z",
    fill: "#EB6502"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M65.8219 29.2785L56.6334 27.2158L54.5707 36.4043L63.7592 38.467L65.8219 29.2785Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M62.809 41.1618L53.6634 39.0957L51.5974 48.2412L60.7429 50.3073L62.809 41.1618Z",
    fill: "#EB6502"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.809 41.1618L53.6634 39.0957L51.5974 48.2412L60.7429 50.3073L62.809 41.1618Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M60.098 53.1496L50.9524 51.0835L48.8864 60.229L58.0319 62.2951L60.098 53.1496Z",
    fill: "#EB6502"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.098 53.1496L50.9524 51.0835L48.8864 60.229L58.0319 62.2951L60.098 53.1496Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3909 65.1381L48.2454 63.072L46.1793 72.2176L55.3248 74.2836L57.3909 65.1381Z",
    fill: "#EB6502"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3756 33.2826L69.3421 27.0503L44.7887 70.5191L55.8222 76.7514L80.3756 33.2826Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0702 34.0168L69.9065 29.4055L65.2952 37.5692L73.4589 42.1805L78.0702 34.0168Z",
    fill: "#EB6502"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M78.0702 34.0168L69.9065 29.4055L65.2952 37.5692L73.4589 42.1805L78.0702 34.0168Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0252 44.7206L63.8615 40.1094L59.2503 48.2731L67.414 52.8843L72.0252 44.7206Z",
    fill: "#EB6502"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.0252 44.7206L63.8615 40.1094L59.2503 48.2731L67.414 52.8843L72.0252 44.7206Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9768 55.4186L57.8131 50.8074L53.2019 58.9711L61.3655 63.5823L65.9768 55.4186Z",
    fill: "#EB6502"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.9768 55.4186L57.8131 50.8074L53.2019 58.9711L61.3655 63.5823L65.9768 55.4186Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9339 66.122L51.7702 61.5107L47.159 69.6744L55.3226 74.2857L59.9339 66.122Z",
    fill: "#EB6502"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2882 45.6454L86.2569 35.8435L47.6403 67.4846L55.6716 77.2865L94.2882 45.6454Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M91.868 45.4956L85.9256 38.2432L78.6732 44.1855L84.6156 51.438L91.868 45.4956Z",
    fill: "#EB6502"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M91.868 45.4956L85.9256 38.2432L78.6732 44.1855L84.6156 51.438L91.868 45.4956Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3619 53.281L76.4195 46.0286L69.1671 51.9709L75.1095 59.2234L82.3619 53.281Z",
    fill: "#EB6502"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M82.3619 53.281L76.4195 46.0286L69.1671 51.9709L75.1095 59.2234L82.3619 53.281Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8527 61.073L66.9103 53.8206L59.6579 59.7629L65.6003 67.0154L72.8527 61.073Z",
    fill: "#EB6502"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.8527 61.073L66.9103 53.8206L59.6579 59.7629L65.6003 67.0154L72.8527 61.073Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3491 68.8615L57.4067 61.6091L50.1543 67.5515L56.0967 74.8039L63.3491 68.8615Z",
    fill: "#EB6502"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M216.752 134.736L222.2 157.6L246.236 151.868L216.752 134.736ZM222.708 142.632L236.116 150.4L225.2 153.02L222.708 142.632Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M256.34 155.076L250.768 132.276L226.768 138.136L256.34 155.076ZM250.34 147.212L236.888 139.5L247.804 136.836L250.34 147.212Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M208.535 122.229L155.354 134.889L163.69 169.91L216.872 157.25L208.535 122.229Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M200.996 128.548L202.448 128.204L207.82 150.78L167.652 160.344L162.28 137.764L193.04 130.44",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M200.996 128.548L202.448 128.204L207.82 150.78L167.652 160.344L162.28 137.764L193.04 130.44",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M207.556 124.219L157.285 136.186L164.858 167.997L215.129 156.03L207.556 124.219Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M214.41 152.905L205.659 154.989L206.401 158.105L215.152 156.022L214.41 152.905Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M205.96 156.032L214.568 153.984",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M206.208 157.088L214.856 155.028",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M164.772 147.448L173.376 145.4L176.404 158.128",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M203.688 127.852L205.808 127.344",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M209.016 150.24L211.14 149.736",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M204.892 127.688L210.224 150.076",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M174.076 145.112L176.196 144.604",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M175.076 145.12L178.048 157.612",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M195.391 131.695L176.771 136.127L178.286 142.489L196.905 138.057L195.391 131.695Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M178.656 135.676L180.112 141.804",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M193.304 132.192L194.76 138.32",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M197.156 139.116L197.436 140.296",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M178.42 143.58L178.7 144.756",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M178.412 144.076L197.148 139.616",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M175.576 137.904C175.51 137.624 175.362 137.369 175.151 137.173C174.94 136.977 174.675 136.848 174.391 136.802C174.107 136.756 173.815 136.796 173.553 136.916C173.291 137.035 173.071 137.23 172.92 137.475C172.769 137.721 172.694 138.005 172.704 138.293C172.715 138.581 172.81 138.859 172.979 139.092C173.148 139.326 173.382 139.504 173.652 139.604C173.922 139.705 174.216 139.723 174.496 139.656C174.871 139.567 175.196 139.332 175.399 139.003C175.601 138.675 175.665 138.279 175.576 137.904Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M193.84 130.264L199.896 128.82",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M168.644 162.04L173.22 160.952",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M168.892 163.096L173.472 162.008",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M169.144 164.152L173.72 163.064",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M186.908 145.54L191.484 144.452",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M187.16 146.596L191.736 145.508",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M187.412 147.652L191.988 146.564",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M178.204 152.2L182.78 151.112",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M178.456 153.256L183.032 152.168",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M178.708 154.312L183.284 153.224",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M166.648 139.08L171.224 137.992",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M166.9 140.136L171.476 139.048",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M167.152 141.192L171.728 140.104",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M206.017 125.94L151.597 131.142L155.022 166.979L209.442 161.777L206.017 125.94Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M197.672 131.172L199.156 131.028L201.364 154.132L160.26 158.06L158.052 134.956L189.532 131.948",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M197.672 131.172L199.156 131.028L201.364 154.132L160.26 158.06L158.052 134.956L189.532 131.948",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M204.777 127.774L153.335 132.691L156.447 165.243L207.888 160.326L204.777 127.774Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M207.602 157.132L198.646 157.988L198.951 161.177L207.907 160.321L207.602 157.132Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M198.792 159.076L207.604 158.236",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M198.896 160.156L207.744 159.312",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M159.184 144.892L167.988 144.048L169.232 157.072",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M200.432 130.852L202.604 130.644",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M202.624 153.76L204.792 153.552",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M201.652 130.856L203.84 153.768",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M168.724 143.856L170.892 143.652",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M169.712 144.008L170.932 156.788",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M191.694 133.501L172.641 135.323L173.263 141.833L192.316 140.012L191.694 133.501Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M174.56 135.148L175.16 141.416",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M189.548 133.716L190.148 139.984",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M192.408 141.108L192.524 142.316",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M173.236 142.94L173.352 144.144",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M173.16 143.432L192.336 141.604",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M171.2 136.928C171.17 136.643 171.056 136.374 170.872 136.154C170.689 135.934 170.445 135.772 170.171 135.691C169.896 135.609 169.604 135.61 169.33 135.694C169.056 135.778 168.813 135.942 168.632 136.163C168.451 136.385 168.339 136.655 168.311 136.94C168.283 137.225 168.34 137.512 168.475 137.765C168.609 138.018 168.816 138.225 169.068 138.361C169.32 138.497 169.607 138.555 169.892 138.528C170.083 138.51 170.269 138.454 170.439 138.364C170.609 138.273 170.759 138.15 170.88 138.001C171.002 137.853 171.093 137.681 171.148 137.497C171.203 137.312 171.22 137.119 171.2 136.928Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M190.348 131.88L196.544 131.288",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M161.004 159.876L165.688 159.428",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M161.108 160.956L165.792 160.508",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M161.212 162.036L165.896 161.588",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M181.376 146.056L186.056 145.608",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M181.476 147.136L186.16 146.688",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M181.58 148.216L186.264 147.768",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M171.832 151.452L176.516 151.004",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M171.936 152.532L176.62 152.084",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M172.04 153.612L176.724 153.164",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M162.2 136.86L166.884 136.412",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M162.304 137.94L166.984 137.492",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M162.404 139.02L167.088 138.576",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M32.952 126.312C32.952 126.312 22.084 131.512 21.712 132.98C21.34 134.448 22.948 149.284 22.948 151.632C22.948 153.98 22.452 153.98 21.712 157.316C20.972 160.652 20.112 162.748 21.96 163.984C23.808 165.22 27.888 167.584 35.916 167.584C43.944 167.584 56.176 163.6 56.8 161.76C57.424 159.92 57.048 148.052 56.924 145.828C56.8 143.604 53.324 128.904 52.476 127.792C51.628 126.68 50.008 126.436 46.672 125.94C43.336 125.444 32.952 126.312 32.952 126.312Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M31.224 148.668C31.224 148.668 26.16 157.808 23.812 162.132C21.464 166.456 20.848 170.776 21.96 175.964C23.072 181.152 28.628 184.736 34.188 184.736C37.3689 184.771 40.5359 184.313 43.576 183.376C43.576 183.376 46.044 185.6 51.108 184.116C56.172 182.632 58.644 177.696 58.152 171.148C57.66 164.6 57.04 152.372 56.916 150.152C56.792 147.932 54.076 148.172 51.976 149.16C49.876 150.148 42.216 161.636 42.216 161.636C42.216 161.636 38.616 150.52 37.152 149.04C35.688 147.56 34.8 146.444 31.224 148.668Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 176.952C43.2 176.952 40.852 180.784 38.876 183.872C36.9 186.96 34.308 189.8 35.172 191.156C36.036 192.512 38.012 193.628 40.236 193.628C42.46 193.628 43.696 193.012 44.312 191.404C44.928 189.796 45.912 183.128 46.66 181.276C47.408 179.424 45.304 175.72 43.2 176.952Z",
    fill: "#EB6502",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M39.26 191.788C36.66 191.312 36.024 189.532 35.92 188.232C35.164 189.468 34.752 190.492 35.176 191.156C36.04 192.516 38.016 193.628 40.24 193.628C42.464 193.628 43.7 193.012 44.316 191.404C44.4214 191.11 44.5109 190.811 44.584 190.508C43.8457 191.1 42.9856 191.522 42.0652 191.744C41.1448 191.965 40.1869 191.98 39.26 191.788Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9 148.052C47.9 148.052 45.552 166.824 44.564 171.396C43.576 175.968 42.712 177.94 42.712 178.312C42.712 178.684 45.304 182.14 46.912 182.264C48.52 182.388 49.876 178.928 52.112 174.852C54.348 170.776 56.556 162.748 58.04 158.672C59.524 154.596 59.64 149.284 58.04 147.308C56.44 145.332 52.22 142.244 47.9 148.052Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M41.656 141.388C42.288 138.428 44.032 130.368 45.016 125.812C40.772 125.66 32.952 126.312 32.952 126.312C32.952 126.312 30.708 127.384 28.228 128.688C29.428 132.516 31.796 139.052 34.576 142.14C38.644 146.66 40.752 145.6 41.656 141.388Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M40.736 140.144C41.34 137.32 43.18 128.812 43.836 125.788C39.472 125.768 32.952 126.312 32.952 126.312C32.952 126.312 31.288 127.112 29.244 128.16C29.96 130.62 32.196 137.724 34.928 140.764C38.264 144.468 40 143.6 40.736 140.144Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M21.976 118.568C21.976 118.568 22.464 119.64 22.464 122.968C22.464 126.296 20.8 127.94 25.1 128.916C29.4 129.892 31.836 128.232 32.128 125.792C32.42 123.352 30.468 121.104 30.956 119.544C31.444 117.984 33.396 114.272 33.104 113.196L32.8 112.124L21.976 118.568Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M41.012 133.7L40.328 125.2L41.6 125.104C43.456 124.704 46 123.836 46 122.468C46 121.1 45.512 118.172 45.416 115.632C45.34 113.817 44.6902 112.074 43.56 110.652C42.876 109.676 42.292 107.724 42.292 107.724L41.492 106.748L31.444 113.1C31.309 114.41 30.9801 115.694 30.468 116.908C29.668 118.568 28.712 119.152 28.712 119.152C28.712 119.152 26.564 117.004 25.88 119.056C25.196 121.108 26.368 122.864 28.224 123.74C30.08 124.616 30.664 122.864 30.664 122.864L32.616 134.4",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M41.012 133.7L40.328 125.2L41.6 125.104C43.456 124.704 46 123.836 46 122.468C46 121.1 45.512 118.172 45.416 115.632C45.34 113.817 44.6902 112.074 43.56 110.652C42.876 109.676 42.292 107.724 42.292 107.724L41.492 106.748L31.444 113.1C31.309 114.41 30.9801 115.694 30.468 116.908C29.668 118.568 28.712 119.152 28.712 119.152C28.712 119.152 26.564 117.004 25.88 119.056C25.196 121.108 26.368 122.864 28.224 123.74C30.08 124.616 30.664 122.864 30.664 122.864L32.616 134.4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2 117.6C44.1995 118.634 42.8307 119.231 41.392 119.26",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4957 115.145C38.7336 115.018 38.7414 114.567 38.513 114.138C38.2846 113.709 37.9066 113.464 37.6687 113.591C37.4308 113.718 37.4231 114.168 37.6514 114.597C37.8798 115.026 38.2578 115.271 38.4957 115.145Z",
    fill: "#263238"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M43.276 111.116C43.504 111.544 43.496 111.996 43.276 112.124C43.056 112.252 42.66 112.004 42.432 111.576C42.204 111.148 42.212 110.696 42.432 110.572C42.652 110.448 43.048 110.688 43.276 111.116Z",
    fill: "#263238"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M39.452 112.024C37.2145 112.788 35.1312 113.945 33.3 115.44L33.7 116.24L34.284 116.532C34.284 116.532 35.448 118 36.8 117.884C38.152 117.768 40.704 116.224 40.9 115.052C41.096 113.88 40.02 112.024 40.02 112.024H39.452Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M39.452 112.024C37.2145 112.788 35.1312 113.944 33.3 115.44L33.7 116.24L34.284 116.532C34.4086 116.674 34.5422 116.807 34.684 116.932C34.684 116.932 34.044 115.936 34.164 115.604C34.752 114.004 40.164 112.32 40.164 112.32L40.116 112.144L40.048 112.02L39.452 112.024Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M40.248 112.184L41.5 111.34C41.9186 112.207 42.5188 112.973 43.26 113.588C44.332 114.368 45.308 114.464 45.308 114.952C45.308 115.44 43.552 116.224 43.552 116.224",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 115.444L28.32 118.86L28.612 119.444L33.692 116.224L33.3 115.444Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M34.96 113.392C35.8394 112.281 37.0859 111.519 38.476 111.244",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M41.308 110.168C41.308 110.168 41.404 109.192 42.672 108.9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M40.328 125.2C39.3106 125.3 38.2834 125.201 37.304 124.908C36.0696 124.509 34.8663 124.02 33.704 123.444C33.704 123.444 36.144 125.2 37.216 125.884C38.288 126.568 40.244 126.96 40.244 126.96L40.328 125.2Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M45.504 109.488C45.1946 109.205 44.8121 109.016 44.4 108.94C43.92 108.94 41.412 110.464 41.2 110.752C40.988 111.04 41.48 111.34 41.48 111.34C41.48 111.34 43.608 109.812 43.996 109.716C44.384 109.62 45.504 109.488 45.504 109.488Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M39.452 112.024L41.22 110.956L41.5 111.356C42.0362 110.883 42.6208 110.467 43.244 110.116C44.412 109.432 45.112 109.316 45.504 109.504C45.896 109.692 46.48 111.356 45.904 112.528C45.5784 113.206 45.0718 113.78 44.44 114.188",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M19.632 121.2C19.632 121.2 22.364 119.732 28.432 115.828C34.5 111.924 47.764 104.992 47.764 104.992C47.764 104.992 42 105.772 39.172 104.892C36.344 104.012 33.788 100.7 31.932 100.6C30.076 100.5 19.632 106.46 19.632 108.316C19.632 110.172 20.996 116.808 21.192 117.116C21.388 117.424 18.752 119.056 19.632 121.2Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M31.94 113.68C31.18 113.884 30.36 114.08 29.492 114.272C26.6273 114.902 23.8449 115.86 21.2 117.128C21.268 117.472 18.776 119.104 19.636 121.204C19.636 121.204 22.368 119.736 28.436 115.832C29.424 115.2 30.628 114.452 31.94 113.68Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M39.16 104.896C38.895 104.812 38.6357 104.71 38.384 104.592C31.656 108.084 23.62 113.46 20.784 115.392C20.892 115.884 20.988 116.296 21.064 116.592C23.6 114.856 32.8 108.66 39.948 105.088C39.6817 105.04 39.4185 104.976 39.16 104.896Z",
    fill: "#263238"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M26.16 135.576C26.8034 137.63 27.551 139.65 28.4 141.628C29.388 143.728 30.252 145.58 30.252 145.58C30.252 145.58 26.4 145.704 24.8 146.8C23.2 147.896 19.028 152.8 19.028 152.8C19.028 152.8 18.872 148.664 18.872 144.712C18.872 140.76 18.996 135.324 19.86 133.964C20.724 132.604 25.172 130.876 25.172 130.876",
    fill: "#EB6502"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M26.16 135.576C26.8034 137.63 27.551 139.65 28.4 141.628C29.388 143.728 30.252 145.58 30.252 145.58C30.252 145.58 26.4 145.704 24.8 146.8C23.2 147.896 19.028 152.8 19.028 152.8C19.028 152.8 18.872 148.664 18.872 144.712C18.872 140.76 18.996 135.324 19.86 133.964C20.724 132.604 25.172 130.876 25.172 130.876",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M46.664 125.94C46.664 125.94 52.84 125.2 54.196 126.312C55.552 127.424 62.596 139.652 62.596 139.652C62.596 139.652 56.296 137.676 55.188 138.664C54.08 139.652 49.988 144.592 49.988 144.592L47.64 130.992",
    fill: "#EB6502"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M46.664 125.94C46.664 125.94 52.84 125.2 54.196 126.312C55.552 127.424 62.596 139.652 62.596 139.652C62.596 139.652 56.296 137.676 55.188 138.664C54.08 139.652 49.988 144.592 49.988 144.592L47.64 130.992",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M55.564 135.6C51.812 135.72 50.048 138.36 49.252 140.292L50 144.592C50 144.592 54.076 139.652 55.2 138.664C56.324 137.676 62.608 139.652 62.608 139.652C62.608 139.652 61.86 138.352 60.808 136.568C59.1499 135.872 57.3613 135.542 55.564 135.6Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M49.88 180.8C49.992 181.092 51.664 185.452 53.332 188.196C55.064 191.04 55.064 191.532 54.32 193.14C53.576 194.748 50.864 195.608 48.516 194.74C46.168 193.872 45.056 193.256 45.056 191.14C45.056 189.024 44.44 181.88 44.44 181.88C44.44 181.88 44.564 178.544 46.664 178.172C48.764 177.8 49.864 180.772 49.864 180.772",
    fill: "#EB6502"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M49.88 180.8C49.992 181.092 51.664 185.452 53.332 188.196C55.064 191.04 55.064 191.532 54.32 193.14C53.576 194.748 50.864 195.608 48.516 194.74C46.168 193.872 45.056 193.256 45.056 191.14C45.056 189.024 44.44 181.88 44.44 181.88C44.44 181.88 44.564 178.544 46.664 178.172C48.764 177.8 49.864 180.772 49.864 180.772",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M51.152 193.32C48.648 193.468 46.04 191.476 45.048 190.628C45.048 190.828 45.048 191.008 45.048 191.156C45.048 193.256 46.16 193.876 48.508 194.756C50.856 195.636 53.572 194.756 54.312 193.156C54.788 192.128 54.956 191.556 54.564 190.532C54 191.76 52.944 193.2 51.152 193.32Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M34.928 146.072C34.928 146.072 32.088 145.952 30.852 149.408C30.052 151.648 29.616 154.844 30.236 156.696C30.856 158.548 43.328 179.796 43.576 180.164C43.824 180.532 44.44 181.896 44.44 181.896C44.44 181.896 45.676 180.66 46.292 180.66C46.908 180.66 49.892 180.784 49.892 180.784C50.1041 179.925 50.061 179.023 49.768 178.188C49.272 176.828 47.296 173.496 47.048 172.012C46.8 170.528 42.852 153.484 41.984 151.384C41.116 149.284 39.252 145.952 34.928 146.072Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M20.108 151.508C20.108 151.508 18.352 155.724 21.036 156.108C23.72 156.492 27.94 150.544 28.516 149.78C29.092 149.016 22.952 147.86 22.952 147.86L20.108 151.508Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M30.236 145.6C30.236 145.6 47.652 152.516 49.132 153.38C50.612 154.244 53.932 158.94 54.444 160.544C54.956 162.148 56.296 166.968 56.42 167.344C56.544 167.72 54.32 171.668 54.196 172.036C54.072 172.404 52.596 174.012 52.1 174.012C51.604 174.012 50.616 171.172 50.368 169.212C50.12 167.252 49.132 157.972 49.132 157.972C49.132 157.972 38.636 155.748 33.692 155.748C28.748 155.748 23.2 153.236 22.208 152.248C21.216 151.26 21.096 149.904 21.712 149.408C22.328 148.912 25.42 144.716 30.236 145.6Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1 173.988V167.812",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M53.088 173.248L53.952 167.072",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M54.692 170.9L55.804 166.948",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M37.276 166.824C37.1807 167.729 36.8528 168.595 36.324 169.336C35.7404 170.18 35.1101 170.99 34.436 171.764C34.436 171.764 35.424 172.876 37.028 171.396C38.632 169.916 39.624 166.824 39.868 166.084C40.112 165.344 38.88 164.48 37.276 166.824Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M51.232 139.9C51.232 139.9 43.576 154.844 41.6 158.424C39.624 162.004 39.624 161.268 38.76 163.12C38.316 164.068 36.176 168.596 36.324 169.336C36.472 170.076 36.772 174.536 36.772 174.536C36.772 174.536 37.216 175.868 37.512 174.684C37.808 173.5 37.808 170.532 37.808 170.532L38.4 168.892C38.4 168.892 39.14 173.784 39.14 174.228C39.14 174.672 39.736 175.708 40.18 175.264C40.624 174.82 40.032 170.668 40.032 170.668L40.624 168.3C40.624 168.3 41.364 173.5 41.824 174.08C42.284 174.66 42.568 175.28 42.864 174.376C43.16 173.472 42.4 170.52 42.4 170.52L42.696 167.852C42.696 167.852 43.288 172.152 43.896 172.744C44.504 173.336 44.788 173.04 44.788 172.004C44.788 170.968 44.044 167.556 44.044 167.556L44.08 160.032C44.08 160.032 54.332 149.532 57.792 145.952C61.252 142.372 64.548 141.596 62.592 138.496C60.732 135.548 54.94 135.944 51.232 139.9Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 152.428C18.9455 152.971 19.1232 153.506 19.332 154.028C19.332 154.028 22.22 148.604 23.828 147.492C25.436 146.38 30.228 145.58 30.228 145.58C30.228 145.58 29.804 144.504 29.428 143.712C29.028 143.684 28.152 143.62 27.692 143.612C21.9 143.484 19.6 150.056 18.8 152.428Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2173_7287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 98.8,
    fill: "white",
    transform: "translate(77.684 26.8882)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.003d51628e1824f6db5563a7765c4d3a.svg";
export { ForwardRef as ReactComponent };